import { render, staticRenderFns } from "./info-tit.vue?vue&type=template&id=8990a7b4&scoped=true"
import script from "./info-tit.vue?vue&type=script&lang=js"
export * from "./info-tit.vue?vue&type=script&lang=js"
import style0 from "./info-tit.vue?vue&type=style&index=0&id=8990a7b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8990a7b4",
  null
  
)

export default component.exports